
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifiOffGoogle as ObiWifiOffGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifi-off-google.js';
 
 
 

 
 export const ObiWifiOffGoogle = createComponent({
   react: React,
   tagName: 'obi-wifi-off-google',
   elementClass: ObiWifiOffGoogleElement,
   events: {
     
   }
  });
 
 